export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

export let BASE_URL = '';
export let CHART_IDS = {};

if (REACT_APP_ENVIRONMENT === 'production') {
  BASE_URL = 'https://charts.mongodb.com/charts-project-0-ypyhz';
  CHART_IDS = Object.freeze({
    // Production Chart ID's
    BOOKING_MONTHLY: '3cd39d2c-cbe4-4730-8b43-df7b921127e0',
    BOOKING_WEEKLY: 'efcdbf83-66d2-4584-ab70-a6a6b6726e11',
    CHARGERSTATUS: '67946984-675c-4d03-bc0a-bb617591e607',
    ENERGYSOLD_MONTHLY: 'e1965bdf-807a-4808-b050-63ab1dec762b',
    ENERGYSOLD_WEEKLY: 'f1de3e43-0902-40d7-8a71-1fa8bba4f291',
    SESSIONS_TODAY: 'efe9cbc2-f987-4a21-931f-873ae06f7baf',
    TOTAL_CHARGESPOTS: 'cda50d52-f367-4575-b19b-3e886297a6ce',
    TOTAL_REVENUE: 'bc522c7d-cb00-412c-b26c-f01a51077104',
    TOTAL_USERS: 'cc6d199a-04e1-4e13-a338-9aaeb07b79a4',
    CHARGER_TYPES: '10c60ef5-6157-4132-aebe-2de9cc2ad7d5',
    UNITS_TODAY: '0dce7a1d-33fc-4b20-93aa-909259c06dca',
    HEATMAP: '6455dab0-53b8-411f-8d67-984ac0aeb821',
    // CDB-494 — Dashboard Revamp (need to be created on prod Atlas Charts)
    V2_REVENUE: '',
    V2_SESSIONS: '',
    V2_UNITS: '',
    V2_ENERGY_DAILY: '',
    V2_ENERGY_WEEKLY: '',
    V2_ENERGY_MONTHLY: '',
    V2_ACTIVE_USERS: '',
    V2_NEW_USERS: '',
  });
} else if ((REACT_APP_API_URL).includes('uat')) {
  BASE_URL = 'https://charts.mongodb.com/charts-project-0-ulbdz';
  // UAT CHART ID's
  CHART_IDS = Object.freeze({
    BOOKING_MONTHLY: '66cf071f-aad8-4c9d-8f1a-d9aaff11d284',
    BOOKING_WEEKLY: '66cf071f-aad8-45ee-8e15-d9aaff11d282',
    CHARGERSTATUS: '66cf071f-aad8-47e5-8b9d-d9aaff11d272',
    ENERGYSOLD_MONTHLY: '66cf071f-aad8-4227-8651-d9aaff11d280',
    ENERGYSOLD_WEEKLY: '66cf071f-aad8-4af0-89f4-d9aaff11d27e',
    SESSIONS_TODAY: '66cf071f-aad8-47d8-8f89-d9aaff11d276',
    // Was a production chart id (project ypyhz) — not resolvable from this project, so the widget
    // rendered "Data Not Found". Uses the chargespots chart that exists in project ulbdz.
    TOTAL_CHARGESPOTS: '66cda6ed-445b-4dad-837a-73f9c834712d',
    TOTAL_REVENUE: '66cf071f-aad8-4337-8dbb-d9aaff11d278',
    TOTAL_USERS: '66cf071f-aad8-43b1-8102-d9aaff11d286',
    CHARGER_TYPES: '66cf071f-aad8-4b7c-8f20-d9aaff11d27c',
    UNITS_TODAY: '66cf071f-aad8-4ffa-8115-d9aaff11d27a',
    HEATMAP: '66cf071f-aad8-4529-8cd9-d9aaff11d28a',
    // CDB-494 — Dashboard Revamp
    V2_REVENUE: 'f267276e-b2fd-4478-820c-2d879971d32c',
    V2_SESSIONS: '8e825bb6-691d-48d3-bd26-80f1963b5ba3',
    V2_UNITS: '36a2eb73-6321-4e50-9d72-404bf851ba32',
    V2_ENERGY_DAILY: 'efefce47-dc85-401d-ba29-d4d58c9d1c0e',
    V2_ENERGY_WEEKLY: 'efefce47-dc85-401d-ba29-d4d58c9d1c0e',
    V2_ENERGY_MONTHLY: '0fda07f8-cd1a-4b02-95db-f49b50b8aa1d',
    V2_ACTIVE_USERS: 'b6ffba01-17cb-4758-805c-b2c72ace5ef9',
    V2_NEW_USERS: '0a3f433f-e1fe-441e-a141-44243e2d89b0',
  });
} else {
  BASE_URL = 'https://charts.mongodb.com/charts-project-0-ulbdz';
  // DEV CHART ID's
  CHART_IDS = Object.freeze({
    BOOKING_MONTHLY: '66cda6ed-445b-4c14-8f07-73f9c834713d',
    BOOKING_WEEKLY: '66cda6ed-445b-4db3-8eb2-73f9c834713b',
    CHARGERSTATUS: '66cda6ed-445b-4afe-8b9a-73f9c834712b',
    ENERGYSOLD_MONTHLY: '66cda6ed-445b-44bf-8078-73f9c8347139',
    ENERGYSOLD_WEEKLY: '66cda6ed-445b-4347-8581-73f9c8347137',
    SESSIONS_TODAY: '66cda6ed-445b-4fcb-8f9f-73f9c834712f',
    TOTAL_CHARGESPOTS: '66cda6ed-445b-4dad-837a-73f9c834712d',
    TOTAL_REVENUE: '66cda6ed-445b-4d6f-8915-73f9c8347131',
    TOTAL_USERS: '66cda6ed-445b-41e8-8a9d-73f9c834713f',
    CHARGER_TYPES: '66cda6ed-445b-4d3e-838d-73f9c8347135',
    UNITS_TODAY: '66cda6ed-445b-4add-8d7e-73f9c8347133',
    HEATMAP: '66cda6ed-445b-4410-8a89-73f9c8347143',
    // CDB-494 — Dashboard Revamp (using UAT IDs as fallback for dev)
    V2_REVENUE: 'f267276e-b2fd-4478-820c-2d879971d32c',
    V2_SESSIONS: '8e825bb6-691d-48d3-bd26-80f1963b5ba3',
    V2_UNITS: '36a2eb73-6321-4e50-9d72-404bf851ba32',
    V2_ENERGY_DAILY: 'efefce47-dc85-401d-ba29-d4d58c9d1c0e',
    V2_ENERGY_WEEKLY: 'efefce47-dc85-401d-ba29-d4d58c9d1c0e',
    V2_ENERGY_MONTHLY: '0fda07f8-cd1a-4b02-95db-f49b50b8aa1d',
    V2_ACTIVE_USERS: 'b6ffba01-17cb-4758-805c-b2c72ace5ef9',
    V2_NEW_USERS: '0a3f433f-e1fe-441e-a141-44243e2d89b0',
  });
}
